import { httpClient } from './httpClient';

const base = '/api/niveles';

export const listarNiveles = () => httpClient.get(base);
export const obtenerNivel = (id) => httpClient.get(`${base}/${id}`);
export const crearNivel = (payload) => httpClient.post(base, payload);
export const actualizarNivel = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarNivel = (id) => httpClient.del(`${base}/${id}`);

const nivelesService = {
  listar: listarNiveles,
  obtener: obtenerNivel,
  crear: crearNivel,
  actualizar: actualizarNivel,
  eliminar: eliminarNivel,
};

export default nivelesService;
